/**
 * required by the backend to delete or move quizzes or folders.
 * Adapted from `Constants.js`
 */
export enum MoveTask {
  DELETE = 1,
  MOVE = 2,
  RESTORE = 3,
}
